<template>
  <div class="container">
    <Loader :loading='loading' />

    <ErrorPage 
      customMessage='Live TV Streaming is currently under maintenance, please visit later'
      code=503
      :url='{name: "live.home"}'
      v-if="!isActive"
    />

    <div class="row player">
      <div class="col-12">
        <VideoPlayer
          :src='channel.path'
          :auto-play='false'
          :title="channel.name"
          :genre="channel.title"
          :thumbnail='channel.logo'
          :is-live='true'
          :update-play-time='false'
          :playlist='categories'
          playlist-title='Browse by categories'
          v-if="channel.path"
        />
        <span class="alert-warning" v-else>
          No live channel was founed please try again
        </span>
      </div>
    </div>

  </div>
</template>

<script>
import ErrorPage from '../../components/ErrorPage';
import VideoPlayer from '../../components/VideoPlayer';
import Loader from '../../components/Loader';
import { log, authRequest, getAuthKey, getAppResource } from '../../app/helpers';
import { apiUrlAuth } from '../../app/config';

export default {
  components: {
    ErrorPage,
    VideoPlayer,
    Loader,
  },

  data() {
    return  {
      isActive: true,
      channel: {},
      loading: true,
      related: [],
      playlist: [],
      categories: [],
    }
  },

  mounted() {
    this.$store.commit('bodyClass', 'stream-page');

    this.getChannel();
    this.getCategories();
  },

  methods: {
    async getChannel() {
      this.loading = true;
      this.related = [];
      this.playlist = [];
      this.channel = {};

      const {id} = this.$route.params;
      const req = await authRequest(this.$router, '/channels/' + id );

      this.channel = req.channel;
      this.related = req.relatedChannels;
      this.loading = false;
    },


    async addWatched() {
      this.$store.commit('isProgressBar', false);

      const req = await authRequest(
        this.$router, '/channel/watched/' + this.channel.channel_id,
        {},
        'post'
      );

      this.$store.commit('isProgressBar', true);
    },


    async getCategories() {
      const categories = await getAppResource('channel-categories');

      if (categories) {
        const catgs = [];
        
        for (const c in categories) {
          catgs.push({
            title: categories[c].title,
            url: this.$router.resolve({
              name: 'live.search',
              query: {
                category: categories[c].title
              }
            }).route.fullPath,
          });
        }

        this.categories = catgs;
      }
    }
  },

  watch: {
    related(v) {
      if (!v) {
        return null;
      }

      let arr = [];

      for (const i in v) {
        arr.push({
          thumbnail: v[i].logo,
          title: v[i].name,
          genre: v[i].title,
          url: '/live/stream/' + v[i].channel_id + '/',
        })  
      }

      this.playlist = arr;
    },

    $route() {
      this.getChannel();
    },


    channel(c) {
      if (c.channel_id) {
        this.addWatched();
      }
    }
  }
}
</script>


<style lang="scss" scoped>

</style>